import Checkout from '@interfaces/checkouts.interface'
import Environment from '@interfaces/environment.interface'
import Prizes from '@interfaces/prizes.interface'
import onEnvironmentChange from '@observables/environment.observable'
import LogService from '@services/log/log.service'
import MainService from '@services/main/main.service'
import { take } from 'rxjs/operators'

export default class SuperboyService extends MainService {
  url: string
  logService = new LogService()

  constructor(superboyUrl?: string) {
    super()
    if (!superboyUrl) {
      onEnvironmentChange.pipe(take(1)).subscribe((environment: Environment) => {
        this.url = environment?.squidApis?.superboy
      })
    } else {
      this.url = superboyUrl
    }
    this.logService.init('SuperboyService Service')
  }

  public async getPrizes(idCampaign: string): Promise<Prizes[]> {
    if (!idCampaign) {
      throw new Error('idCampaign is required')
    }
    const headers = await this.getHeaders()
    return this.http
      .get(`${this.url}/hub/campaigns/${idCampaign}/prizes`, {
        headers,
      })
      .then((r: any) => r.data || {})
      .catch((error: any) => {
        this.logService.error({
          message: 'Error on get prizes',
          error,
        })
        throw error.response
      })
  }

  public async getCheckouts(status?: string, idCampaigns?: string | Array<string>): Promise<Checkout[]> {
    let query = '?type=any'
    if (status) {
      query += `&status=${status}`
    }
    if (idCampaigns) {
      query += `&campaigns=${Array.isArray(idCampaigns) ? idCampaigns.toString() : idCampaigns}`
    }
    const headers = await this.getHeaders()
    return this.http
      .get(`${this.url}/hub/checkouts/user/self${query}`, {
        headers,
      })
      .then((r: any) => r.data || {})
      .catch((error: any) => {
        this.logService.error({
          message: 'Error on get checkouts',
          error,
        })
        throw error.response
      })
  }

  public async postCheckout(idCampaign: string, idPrize: string, idSocialNetwork: string): Promise<Checkout> {
    if (!idCampaign) {
      throw new Error('Must contain a valid idCampaign')
    }
    if (!idPrize) {
      throw new Error('Must contain a valid idPrize')
    }
    const headers = await this.getHeaders()
    return this.http
      .post(
        `${this.url}/hub/campaign/${idCampaign}/prizes/${idPrize}/checkout/${idSocialNetwork}`,
        {},
        {
          headers,
        }
      )
      .then((r: any) => r.data || {})
      .catch((error: any) => {
        this.logService.error({
          message: 'Error on post checkouts',
          error,
        })
        throw error.response
      })
  }
}
